export default class Address {
  street1: string;
  street2: string;
  city: string;
  province: string;
  provinceCode: string;
  country: string;
  countryCode: string;
  postalCode: string;

  constructor(address: ContactAddress | null) {
    this.street1 = address?.address1 || '';
    this.street2 = address?.address2 || '';
    this.city = address?.city || '';
    this.province = address?.state || '';
    this.provinceCode = address?.stateCode || '';
    this.country = address?.country || '';
    this.countryCode = address?.countryCode || '';
    this.postalCode = address?.zip || '';
  }
}
